import React from "react";
import { useLocation } from "react-router-dom";
import { LIST_MENU_MOBILE } from "./constant";

const MobileMenu = () => {
  let pathname = useLocation().pathname;

  const temp = pathname.split("/");
  if (temp.length > 2) {
    pathname = "/" + temp[1];
  }

  const checkActiveLink = (linkList) => {
    const result = linkList.find((item) => item === pathname);
    return result ? "active" : "";
  };

  return (
    <div className="w-100 navbar-mobile fixed-bottom px-2">
      {LIST_MENU_MOBILE.map((item, index) => (
        <a
          key={index}
          className={"navbar-mobile-item " + checkActiveLink(item.path)}
          href={item.path[0]}
        >
          {item.svg}
        </a>
      ))}
    </div>
  );
};

export default MobileMenu;
